// frontend/src/components/dialogs/BookingCancelDialog.js
import React from 'react';
import { LucideSave, BookX } from 'lucide-react';
import { t } from 'i18next';
import { formatDate, formatTimeString } from '../../utils/dateTimeFormatter';
import { useDateTimePreferences } from '../../hooks/useDateTimePreferences';
import { useTheme } from '../../contexts/ThemeContext';
import ConfirmDialogShell from './ConfirmDialogShell';

export const BookingCancelDialog = ({
    isOpen,
    onClose,
    onConfirm,
    bookingDetails,
    isProcessing = false
}) => {
    // Force re-render when preferences change
    useDateTimePreferences();
    const { background, text, cn } = useTheme();
    
    if (!bookingDetails) return null;

    return (
        <ConfirmDialogShell
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={onConfirm}
            title={t('cancelBooking')}
            confirmLabel={t('confirmCancel')}
            cancelLabel={t('keepBooking')}
            confirmVariant="danger"
            confirmIcon={LucideSave}
            cancelIcon={BookX}
            isLoading={isProcessing}
        >
            <div className="space-y-4">
                <p className="text-red-500 dark:text-red-400">
                    {t('areYouSureYouWantToCancelThisBooking?')}
                </p>

                <div>
                    <p className={cn("font-medium", text.primary)}>{t('Route')}</p>
                    <p className={text.secondary}>{bookingDetails.routeName}</p>
                </div>

                <div>
                    <p className={cn("font-medium", text.primary)}>{t('date')}</p>
                    <p className={text.secondary}>                    
                        {formatDate(bookingDetails.date)}
                    </p>
                </div>

                <div>
                    <p className={cn("font-medium", text.primary)}>{t('time')}</p>
                    <p className={text.secondary}>                    
                        {formatTimeString(bookingDetails.time)}
                    </p>
                </div>

                <div>
                    <p className={cn("font-medium", text.primary)}>{t('Passengers')}</p>
                    <p className={text.secondary}>{bookingDetails.passengers}</p>
                </div>
            </div>
        </ConfirmDialogShell>
    );
};

export default BookingCancelDialog;
